import { ReceiveStoreTypeCodes } from '../constants';

export const isCostCenterMatchReceiveType = (
  ccTypeId: string | number,
  ccId: string | number
): boolean => {
  if (
    ReceiveStoreTypeCodes.COST_CENTER_TYPE_PLANT === Number(ccTypeId) &&
    ReceiveStoreTypeCodes.COST_CENTER_PLANT === Number(ccId)
  ) {
    return true;
  }

  if (
    ReceiveStoreTypeCodes.COST_CENTER_TYPE_OVERHEAD === Number(ccTypeId) &&
    Number(ccId)
  ) {
    return true;
  }

  return false;
};
